export const MOVE_CALENDAR = 370;
export const LENGTH_CALENDAR = 10;
export const MAX_NIGHTS_PACKAGES_HOTELS = 30;
